


export type WorkspaceType = 'Direct' | 'Group' | 'News' | 'Info' | 'Project' | 'Customer' | 'Supplier' | 'Private' | 'AI' | 'Emergency' | 'CostCentre';

export const WorkspaceType = {
    Direct: 'Direct' as WorkspaceType,
    Group: 'Group' as WorkspaceType,
    News: 'News' as WorkspaceType,
    Info: 'Info' as WorkspaceType,
    Project: 'Project' as WorkspaceType,
    Customer: 'Customer' as WorkspaceType,
    Supplier: 'Supplier' as WorkspaceType,
    Private: 'Private' as WorkspaceType,
    AI: 'AI' as WorkspaceType,
    Emergency: 'Emergency' as WorkspaceType,
    CostCentre: 'CostCentre' as WorkspaceType
};

